import { create } from "zustand";

export let useMessageModal = create((set, get) => ({
  display: false,
  text: "",

  showMessageModal: (messageType) => {
    let messageText = "";

    switch (messageType) {
      case "accessForbidden":
        messageText = "You don't have permission to perform this action.";
        break;
      default:
        messageText = messageType || "An error occurred.";
    }

    set({ display: true, text: messageText });
  },

  close: () => {
    set({ display: false, text: "" });
  },
}));
